/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import Slider from "react-slick";
import "@qlik/qlik/src/assets/vendor/slick/slick.css";
import "@qlik/qlik/src/assets/vendor/slick/slick-theme.css";

/**
 * Default settings for the Content Slider
 * @type {Object}
 */
const defaultSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
};

/**
 * ContentSlider component
 * @param {Object} settings - The settings for the Content Slider
 * @param {Object} children - The children elements to be rendered in the Slider
 * @param {Object} props - The additional props for the Slider
 * @returns {JSX.Element} The ContentSlider component
 */
const ContentSlider = ({ settings, children, ...props }) => {
    /**
     * Merging default settings, user defined settings and additional props
     * @type {Object}
     */
    const sliderSettings = {
        ...defaultSettings,
        ...settings,
        ...{ className: "qlikSlider" },
    };

    /**
     * Rendering the Slider with the defined settings and children
     * @returns {JSX.Element} The Slider component
     */
    return (
        <Slider {...sliderSettings} {...props}>
            {children}
        </Slider>
    );
};

export default ContentSlider;
